export default __webpack_public_path__ + "static/117-6b4ad25aa4e4b3bcd558a74a3360272e.jpg";